<template>
    <div>
        <p>
            {{ $t('postSurgery.addPopup.description') }}
        </p>
        <select-field
            v-model="innerDate"
            :field="{label: $t('datefield.day')}"
            field-name="day"
            :prefix-field-name="prefix"
            :choices="dayChoices"
            :errors="errors"
        />
        <date-field
            v-model="innerDate"
            :field="{label: $t('utils.date')}"
            field-name="date"
            :prefix-field-name="prefix"
            :choices="dayChoices"
            :errors="errors"
            :inline="false"
        />

        <create-cancel-buttons
            :ok-title="$t('utils.add')"
            :ok-function="dateSelected"
            :cancel-title="$t('utils.cancel')"
            :cancel-function="() => $emit('close')"
        />
    </div>
</template>

<script>
    import SelectField from "@/components/fields/SelectField";
    import DateField, {DATE_FORMAT} from "@/components/fields/DateField";
    import {range} from "lodash";
    import moment from "moment";
    import {mapState} from "vuex";
    import {required} from "vuelidate/lib/validators";
    import CreateCancelButtons from "@/components/surgery/detail/elements/CreateCancelButtons";

    const INI_RANGE = 0;
    const END_RANGE = 31;

    export default {
        name: "DetailSurgeryDay",
        components: {CreateCancelButtons, DateField, SelectField},
        data() {
            return {
                prefix: 'add-post-surgery',
                innerDate: null
            };
        },
        computed: {
            ...mapState(['surgery']),
            dayChoices() {
                return range(INI_RANGE, END_RANGE).map(day => {
                    const surgeryDate = moment(this.surgery.date, moment.ISO_8601, true);
                    return {
                        'value': surgeryDate.add(day, 'days').format(DATE_FORMAT),
                        'display_name': day,
                    };
                });
            },
            errors() {
                if (this.$v.innerDate.$error) {
                    return {'date': [this.$t('error.required')]};
                }
                return {};
            },
        },
        methods: {
            dateSelected() {
                this.$v.$touch();
                const isValid = !this.$v.$invalid;
                if (isValid) {
                    this.$emit('dateselected', this.innerDate);
                }
                return isValid;
            },
        },
        validations: {
            innerDate: {
                required,
            },
        }
    };
</script>

<style scoped>

</style>